// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"268":"css/admin-app.6965","6770":"css/app.6965"}[chunkId] + ".css";
};